import { render } from "./PlatformEmailSmtpCard.vue?vue&type=template&id=23f9d502&scoped=true"
import script from "./PlatformEmailSmtpCard.vue?vue&type=script&lang=js"
export * from "./PlatformEmailSmtpCard.vue?vue&type=script&lang=js"

import "./platformEmail.css?vue&type=style&index=0&id=23f9d502&scoped=true&lang=css&external"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23f9d502"]])

export default __exports__